import { render, staticRenderFns } from "./SocialMedias.vue?vue&type=template&id=26d397e8&scoped=true&"
import script from "./SocialMedias.vue?vue&type=script&lang=js&"
export * from "./SocialMedias.vue?vue&type=script&lang=js&"
import style0 from "./SocialMedias.vue?vue&type=style&index=0&id=26d397e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d397e8",
  null
  
)

export default component.exports